export const joystickSpeedMultiplier = 0.000025;
export const SERVER_ENDPOINT = "https://ecommerce-dev.bitreel.com";
export const STORAGE_KEY = "bitreel_e_commerce_products";
export const S3_STORE_CONFIG_URL = "https://bitreel-configs.s3.amazonaws.com";
export const GOOGLE_QR_CODE_GENERATOR =
  "https://chart.googleapis.com/chart?cht=qr&chs=300x300&chl=";
export const BITREEL_LOGO =
  "https://bitreel-arshowrooms.s3.amazonaws.com/SharedFiles/bitreel_logo.png";
